import Hero from '@/components/Hero/Hero';
import FeaturesSection from '@/components/Home/FeaturesSection';

/**
 * ORDER: hero → the five-tab product demo → "How Prinotes helps you"
 * (owner, 2026-09-07). The demo used to sit BELOW the disclosure band, and
 * below it inside the hero's own <section>.
 *
 * It is composed here rather than inside Hero because the disclosure band is
 * not part of the hero: it paints its own full-bleed background and hairline,
 * and nested inside the hero section it left the hero's 80px bottom padding
 * stranded underneath as a strip of the wrong colour. As a sibling it ends
 * where its background ends. It carries its own `dir`, so nothing was
 * inherited from the hero.
 */
export default function HomePage() {
  return (
    <>
      <Hero />
      <FeaturesSection />
    </>
  );
}
